import { showDate } from "../../../../../utilities/helper";

export interface EmployeePersonalInfo {
  aadhar_Number: string;
  pan_Number: string;
  phone_Number: string;
  whatsApp_Number: string;
  us_Phone_Number: string;
  official_Email: string;
  personal_Email: string;
  managerCode?: string;
  teamLeadCode?: string;
  branchHeadCode?: string;

  reference: string;
  emergency_Contact_Name: string;
  emergency_Contact_Number: string;
  manager: string;
  managerId: number;
  teamLead: string;
  teamLeadId: number;
  reference_id: number;
  referred_By: string;
  gender_Id: number;
  gender: string;
  blood_Group_Id: number;
  blood_Group: string;
  dob: string;
  current_Zipcode: string;
  current_Country: string;
  current_State: string;
  current_City: string;
  current_Address: string;

  permanent_Zipcode: string;
  permanent_Country: string;
  permanent_State: string;
  permanent_City: string;
  permanent_Address: string;

  isManager: boolean;
  isTeamLead: boolean;

  marital_Status_Id: number | undefined;
  marital_Status?: string;
  marriage_Date?: string;

}

type PersonalInfoKey = keyof EmployeePersonalInfo;

interface PersonalInfoHeader {
  key: PersonalInfoKey;
  label: string;
}
interface FamilyInfoHeader {
  key: PersonalInfoKey;
  label: string;
  modifier?: any
}

interface PersonalInfoHeader {
  key: PersonalInfoKey;
  label: string;
  modifier?: any
}

export const Identity: PersonalInfoHeader[] = [
  { key: "aadhar_Number", label: "Aadhar Number" },
  { key: "pan_Number", label: "Pan Number" },
];

export const Contact: PersonalInfoHeader[] = [
  { key: "phone_Number", label: "Personal Phone Number" },
  { key: "whatsApp_Number", label: "WhatsApp Number" },
  { key: "us_Phone_Number", label: "US Phone" },
  { key: "official_Email", label: "Official Email" },
  { key: "personal_Email", label: "Personal Mail" },
];

export const Address: PersonalInfoHeader[] = [
  { key: "current_Address", label: "Current Address" },
  { key: "permanent_Address", label: "Permanent Address" },
];

export const EmergencyContacts: PersonalInfoHeader[] = [
  { key: "emergency_Contact_Name", label: "Emergency Contact Name" },
  { key: "emergency_Contact_Number", label: "Emergency Contact Number" },
];

export const ReferenceDetail: PersonalInfoHeader[] = [
  { key: "reference", label: "Reference" },
  { key: "referred_By", label: "Referred By" },
];

export const HeirarchyDetal: PersonalInfoHeader[] = [
  { key: "manager", label: "Manager" },
  { key: "teamLead", label: "Team Lead" },
];

export const BasicDetal: FamilyInfoHeader[] = [
  { key: "gender", label: "Gender" },
  { key: "blood_Group", label: "Blood Group" },
  { key: "dob", label: "Date Of Birth", modifier: (data: any) => { return showDate(data) } },
];

export const HeirarchyCheck: PersonalInfoHeader[] = [
  { key: "isManager", label: "Manager" },
  { key: "isTeamLead", label: "Team Lead" },
];

export const IMarital: PersonalInfoHeader[] = [
  { key: "marital_Status", label: "Marital Status" },
  { key: "marriage_Date", label: "Anniversary Date", modifier: (data: any) => { return showDate(data) } },

]

